import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { Competition } from '@/types/domain';
import type { SportFilterValue } from '@/components/shared/SportFilter';
import CompetitionGameList from './CompetitionGameList';
import { filterCompetitionsBySport } from './filterCompetitionsBySport';

export interface MyPicksTabProps {
  competitions: Competition[];
  selectedSport: SportFilterValue;
  isLoading: boolean;
  showBodyAds: boolean;
  onGameAction: (gameId: string) => void;
  onViewLeaderboard: (gameId: string) => void;
  onMenuClick: (gameId: string) => void;
}

/**
 * My Picks tab — active entered contests (completed games go to Recent).
 * Empty state: Figma 10203:62430
 */
const MyPicksTab: React.FC<MyPicksTabProps> = ({
  competitions,
  selectedSport,
  isLoading,
  showBodyAds,
  onGameAction,
  onViewLeaderboard,
  onMenuClick,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const games = useMemo(() => {
    return filterCompetitionsBySport(competitions, selectedSport).filter(
      g => g.hasSelections && g.state !== 'final'
    );
  }, [competitions, selectedSport]);

  return (
    <CompetitionGameList
      games={games}
      isLoading={isLoading}
      skeletonCount={3}
      emptyTitle={t('pages.noPicksSubmitted')}
      emptySubtitle={t('pages.noPicksSubmittedSubtitle')}
      emptyActionLabel={t('pages.viewAvailableContests')}
      onEmptyAction={() => navigate('/main/lobby')}
      showEmptyIcon
      showBodyAds={showBodyAds}
      variant="myPicks"
      onGameAction={onGameAction}
      onViewLeaderboard={onViewLeaderboard}
      onMenuClick={onMenuClick}
    />
  );
};

export default MyPicksTab;
